<template>
    <div class="prezi-shlb">
        <div class="cover"></div>
        <iframe id="iframe_container"
                frameborder="0"
                allow="autoplay"
                src="https://prezi.com/embed/51iwmmr439wg/?bgcolor=ffffff&amp;lock_to_path=0&amp;autoplay=4&amp;autohide_ctrls=0&amp;landing_data=bHVZZmNaNDBIWnNjdEVENDRhZDFNZGNIUE43MHdLNWpsdFJLb2ZHanI5N1pRemFxb1ZubVgyNmlQZ0Z5aHVpcDlnPT0&amp;landing_sign=HXXSVzc62DZcfOWBku7xcIoOg7gmMSjjYCBc3Wecpas"
        ></iframe>
    </div>
</template>

<script>
    export default {
        name: "SHLB"
    }
</script>

<style lang="scss" scoped>
    .prezi-shlb {
        height: calc(100vh - 35px);
        width: calc(100vw - 35px);
        .cover {
            background-color: black;
            position: absolute;
            top: 0;
            left: 0;
            height: 63px;
            width: calc(100vw);
        }
        #iframe_container {
            margin: 15px;
            height: 100%;
            width: 100%;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/SHLB.vue